<div class="bg-white flex flex-col relative" style="min-height: 100dvh">
  <!-- BACKGROUND -->
  <img src="/assets/images/bg_city_169.webp" class="absolute inset-0 w-full h-full object-cover" alt="Background" />

  <!-- CONTENT -->
  <div class="flex-grow flex items-center justify-center relative">
    <router-outlet></router-outlet>
  </div>
  <!-- FOOTER -->
  <span class="text-gray-600 text-center py-3 relative z-10"> © 2025 Chicilon Media. All rights reserved. </span>
</div>
